import React, { useState, useEffect } from 'react';
import './SmartClassEducation.css';

// Import images for Smart Class
import smartclass1 from '../assets/smartclass (1).webp';
import smartclass2 from '../assets/smartclass (2).webp';
import smartclass3 from '../assets/smartclass (3).webp';
import smartclass4 from '../assets/smartclass (4).webp';

const SmartClass = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const smartclassImages = [smartclass1, smartclass2, smartclass3, smartclass4];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === smartclassImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? smartclassImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === smartclassImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="smartclass-container">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>SMART CLASS EDUCATION</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Smart Class Eduction</li>
          </ul>
        </div>
      </section>
      {/* Main Content */}
      <div className="smartclass-main-content">
        <div className="smartclass-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`smartclass-text-content ${isVisible ? 'smartclass-visible' : ''}`}>
            <h2 className="smartclass-main-heading">SMART CLASS EDUCATION</h2>
            
            <p className="smartclass-intro-text">
              Interactive white boards are used for classroom teaching and involve students to learn with 
              technology. Notes, flowcharts, drawings and PPTs used in the course of teaching are saved to 
              be accessed as and when required. Students are actively involved in their learning through 
              presentations made by them using the whiteboards.
            </p>

            <div className="smartclass-feature">
              <h3 className="smartclass-feature-title">Interactive Learning Environment:</h3>
              <p className="smartclass-feature-text">
                Smart Class technology transforms traditional classrooms into dynamic learning spaces. Students 
                engage with multimedia content, interactive simulations, and digital resources that make complex 
                concepts easier to understand and more engaging.
              </p>
            </div>

            <div className="smartclass-feature">
              <h3 className="smartclass-feature-title">Enhanced Visual Learning:</h3>
              <p className="smartclass-feature-text">
                With high-definition displays and interactive tools, teachers can present information through 
                videos, animations, 3D models, and virtual experiments. This visual approach helps students 
                grasp difficult concepts more effectively and retain information longer.
              </p>
            </div>

            <div className="smartclass-feature">
              <h3 className="smartclass-feature-title">Collaborative Learning:</h3>
              <p className="smartclass-feature-text">
                Students can work together on the interactive board, share their ideas, and solve problems 
                collaboratively. This promotes teamwork, critical thinking, and communication skills essential 
                for the 21st century.
              </p>
            </div>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`smartclass-image-slider ${isVisible ? 'smartclass-visible' : ''}`}>
            <div className="smartclass-slider-container">
              {smartclassImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Smart Class ${index + 1}`}
                  className={`smartclass-slider-image ${
                    index === currentImageIndex ? 'smartclass-active' : ''
                  }`}
                />
              ))}
              
              <button 
                className="smartclass-slider-arrow smartclass-arrow-left"
                onClick={handlePrevImage}
              >
                ‹
              </button>
              <button 
                className="smartclass-slider-arrow smartclass-arrow-right"
                onClick={handleNextImage}
              >
                ›
              </button>
              
              <div className="smartclass-slider-dots">
                {smartclassImages.map((_, index) => (
                  <span
                    key={index}
                    className={`smartclass-dot ${
                      index === currentImageIndex ? 'smartclass-dot-active' : ''
                    }`}
                    onClick={() => handleDotClick(index)}
                  ></span>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        <div className={`smartclass-additional-section ${isVisible ? 'smartclass-visible' : ''}`}>
          <div className="smartclass-feature">
            <h3 className="smartclass-feature-title">Access to Digital Resources:</h3>
            <p className="smartclass-feature-text">
              Teachers have instant access to a vast library of educational content, including e-books, 
              educational videos, simulations, and online resources. This enriches the learning experience 
              and provides diverse perspectives on every topic.
            </p>
          </div>

          <div className="smartclass-feature">
            <h3 className="smartclass-feature-title">Personalized Learning:</h3>
            <p className="smartclass-feature-text">
              Smart Class technology allows teachers to adapt their teaching methods to suit different 
              learning styles. Visual learners, auditory learners, and kinesthetic learners all benefit 
              from the multi-sensory approach that smart classrooms offer.
            </p>
          </div>

          <div className="smartclass-feature">
            <h3 className="smartclass-feature-title">Real-Time Assessment:</h3>
            <p className="smartclass-feature-text">
              Teachers can conduct instant quizzes and assessments through the smart board, getting immediate 
              feedback on student understanding. This enables timely intervention and personalized support 
              for students who need it.
            </p>
          </div>

          <p className="smartclass-conclusion-text">
            At Bihani Children's Academy, our Smart Class infrastructure represents our commitment to 
            providing world-class education. We believe that integrating technology into learning prepares 
            students for the digital future while making education more engaging, interactive, and effective.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SmartClass;